import { SearchInput, useSermonSearchController } from '@nucleus/sermon-theme-elements';
import { SermonSearchRequestBlockWeb } from '@nucleus/types/web/sections/sermon-search-request';
import { SkeletonBlock } from '@nucleus/web-theme-elements';
import React, { useState } from 'react';
import styled from 'styled-components';
import { BlockProps } from '../types/component';
import { BlockInfo } from './BlockInfo';

type BlockSermonSearchRequestProps = Extract<
  BlockProps,
  { block?: SermonSearchRequestBlockWeb; sectionType?: 'sermonSearchRequest' }
>;

export const BlockSermonSearchRequest = ({ block, ...props }: BlockSermonSearchRequestProps): JSX.Element => {
  const { searchQuery, setSearchQuery } = useSermonSearchController();
  const [queryValue, setQueryValue] = useState(searchQuery);

  const updateSearchQuery = (searchQuery: string) => {
    setQueryValue(searchQuery);
  };

  const submitSearchQuery = (searchQuery: string) => {
    setQueryValue(queryValue);
    setSearchQuery(queryValue);
  };
  return (
    <BlockInfo {...props} block={block}>
      <SearchInput
        searchQuery={queryValue}
        updateSearchQuery={updateSearchQuery}
        submitSearchQuery={submitSearchQuery}
      />
    </BlockInfo>
  );
};

export const BlockSermonSearchRequestFallback = ({ block, ...props }: BlockSermonSearchRequestProps): JSX.Element => {
  return (
    <BlockInfo {...props} block={block}>
      <SearchInputSkeleton />
    </BlockInfo>
  );
};

const SearchInputSkeletonContainer = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 24px;
  width: 508px;
  max-width: 100%;
`;

const SearchInputSkeletonInput = styled(SkeletonBlock)`
  flex: 1;
  height: 50px;
`;

const SearchInputSkeletonButton = styled(SkeletonBlock)`
  width: 100px;
  height: 50px;
`;

const SearchInputSkeleton = (): JSX.Element => {
  return (
    <SearchInputSkeletonContainer>
      <SearchInputSkeletonInput />
      <SearchInputSkeletonButton />
    </SearchInputSkeletonContainer>
  );
};
